export default {
  siteName: 'AcanPro',
  userLocalstorage: 'adminuserinfo',
  userToken: 'user-token',
  apiUrl:'/api',
  videoFormats: ["pal", "ntsc", "720p50", "720p59.94", "720p60", "1080i50", "1080i59.94", "1080i60", "1080p23.98", "1080p24", "1080p25", "1080p29.97", "1080p30", "1080p50", "1080p59.94", "1080p60"]
}